import {
    ADD_DASHBOARD_USER_KPI,
    DELETE_DASHBOARD_USER_KPI,
    GET_DASHBOARD_ALL_KPIS,
    GET_DASHBOARD_UPCOMING_APPTS,
    GET_DASHBOARD_USER_FILTERED_KPIS,
    GET_DASHBOARD_USER_KPIS,
    REORDER__DASHBOARD_KPIS,
} from './dashboard.types';

/** Dashboard */

export const getUserFilteredKpis = (params) => {
    return {
        type: GET_DASHBOARD_USER_FILTERED_KPIS,
        payload: { params },
    };
};

export const getAllKpis = (params) => {
    return {
        type: GET_DASHBOARD_ALL_KPIS,
        payload: { params },
    };
};

export const getUserKpis = (params) => {
    return {
        type: GET_DASHBOARD_USER_KPIS,
        payload: { params },
    };
};

export const reorderKpis = (body, params) => {
    return {
        type: REORDER__DASHBOARD_KPIS,
        payload: { body, params },
    };
};

export const deleteUserKpi = (id, params) => {
    return {
        type: DELETE_DASHBOARD_USER_KPI,
        payload: { id, params },
    };
};

export const addUserKpi = (id, params) => {
    return {
        type: ADD_DASHBOARD_USER_KPI,
        payload: { id, params },
    };
};

/** Dashboard Widgets Data */

export const getWidgetsData = (type, url, params) => {
    return {
        type,
        payload: { url, params },
    };
};

/** End */

/** End */
